











import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
} from "@nuxtjs/composition-api";
import { useOtpLogin } from "~/modules/customer/composables/useOtpLogin";
import { useUiNotification } from "~/composables";
import { useCaptCha } from "~/composables/useCaptCha";

declare const GoCaptcha: any;

export default defineComponent({
  name: "GoCaptcha",
  props: {
    mobileNumber: {
      type: String,
      required: false,
    },
    visitorId: {
      type: String,
      required: false,
    },
    isOtpSent: {
      type: Boolean,
      required: true,
    },
    isChooseOptionOtp: {
      type: Boolean,
      required: true,
    },
    hidePopupCaptcha: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { send: sendNotification } = useUiNotification();
    const { otpVerifyCaptcha, loading, result } = useOtpLogin();
    const { confirmEvent, requestCaptchaData, captKey } = useCaptCha();
    const captchaRef = ref<HTMLElement | null>(null);

    let captchaInstance: any = null;

    const initCaptcha = () => {
      captchaInstance = new GoCaptcha.Slide({
        width: 300,
        height: 220,
        title: "Xác nhận để tiếp tục!",
      });
      captchaInstance.setEvents({
        move(x: number, y: number) {},
        confirm(point: { x: number; y: number }, reset: Function) {
          confirmEvent(point, captKey, props.mobileNumber, props.visitorId, emit, sendNotification, otpVerifyCaptcha, result, loading, captchaInstance);
        },
        refresh() {
          captchaInstance.clear();
          requestCaptchaData(captchaInstance, captKey).then(newCaptKey => {
            captKey.value = newCaptKey;
          });
        },
        close() {
          emit("update:hidePopupCaptcha", true);
        },
      });
      requestCaptchaData(captchaInstance, captKey).then(newCaptKey => {
        captKey.value = newCaptKey;
      });

      if (captchaRef.value) {
        captchaInstance.mount(captchaRef.value);
      }
    };

    onMounted(() => {
      const script = document.createElement("script");
      script.src =
        "https://unpkg.com/go-captcha-jslib@1.0.9/dist/gocaptcha.global.js";
      script.onload = () => {
        const link = document.createElement("link");
        link.href =
          "https://unpkg.com/go-captcha-jslib@1.0.9/dist/gocaptcha.global.css";
        link.rel = "stylesheet";
        link.onload = () => {
          initCaptcha();
        };
        document.head.appendChild(link);
      };
      document.head.appendChild(script);
    });

    onBeforeUnmount(() => {
      if (captchaInstance) {
        captchaInstance.destroy();
      }
    });

    return {
      captchaRef,
      loading,
      captKey,
    };
  },
});
